import { useContext } from 'react'
import { FABContext } from './FABProvider'
import type { FABContextValue } from './types'

export function useFAB(): FABContextValue {
  const context = useContext(FABContext)
  if (!context) {
    throw new Error('useFAB must be used within a FABProvider')
  }
  return context
}
